export default "__VITE_ASSET__BolxLmlo__"